<h1 class="d-none">Achetez des articles eco responsables sur la marketplace 100% française.</h1>
<div>

  <!-- SLIDER -->
  <div class="p-0 hero sliderBox" *ngIf="sliders.length">
    <carousel [interval]="3200" [isAnimated]="false">
      <slide *ngFor="let item of sliders">
        <div class="d-flex align-items-center slider position-relative" [ngClass]="{'justify-content-center': item.slider.niveau_affichage === 'CENTER','justify-content-end': item.slider.niveau_affichage === 'RIGHT'}">
          <img class="w-100 h-100 position-absolute" [src]="commonService.getImageFormated(0, 0, item.slider.publicice_detail.file.url)">
          <div [ngClass]="{'text-center':item.slider.niveau_affichage === 'CENTER', 'text-right': item.slider.niveau_affichage === 'RIGHT'}" style="padding-left: 70px; padding-right: 70px;z-index: 1;">
            <h2 class="slider--title mb-0 PoppinsSemiBold" style="font-size: 43px;letter-spacing: 2px;" [ngStyle]="{'color': getColor(item.slider.publicice_detail.couleur_texte)}">
              {{item.slider.publicice_detail.texte_achrochage}}</h2>
              <h3 class="PoppinsRegular d-md-block d-none" [ngClass]="{'text-center':item.slider.niveau_affichage === 'CENTER'}" style="font-size: 27px; text-align: left;margin-top: 0px;"
              [ngStyle]="{'color': getColor(item.slider.couleur_phrase), 'margin-bottom': ((item.slider.publicice_detail.choix === 'BOUTIQUE' && item.vendeur) || item.slider.publicice_detail.choix !== 'BOUTIQUE') ? '0px': '60px'}">{{item.slider.phrase_acrochage | titlecase}}</h3>
            <!-- <h3 class="font-weight-bold PoppinsRegular d-md-block d-none" [ngClass]="{'text-center':item.slider.niveau_affichage === 'CENTER'}" style="font-size: 27px; text-align: left;margin-top: 0px;"
              [ngStyle]="{'color': getColor(item.slider.couleur_phrase), 'margin-bottom': ((item.slider.publicice_detail.choix === 'BOUTIQUE' && item.vendeur) || item.slider.publicice_detail.choix !== 'BOUTIQUE') ? '0px': '60px'}">{{item.slider.phrase_acrochage | titlecase}}</h3> -->
            <button
              *ngIf="(item.slider.publicice_detail.choix === 'BOUTIQUE' && item.vendeur) || item.slider.publicice_detail.choix !== 'BOUTIQUE'"
              class="{{getStyleButton(item.slider.publicice_detail.style_bouton)}} mx-auto"
              [routerLink]="[item.slider.publicice_detail.choix === 'BOUTIQUE'?'/detail-vendeur/'+item.vendeur.user.id : 'all-product/'+item.link.univers+'/'+item.link.sousUnivers+'/'+item.link.categorie]"
              [queryParams]="{vendeur: item.slider.publicice_detail.choix === 'BOUTIQUE' ? item.vendeur.user.id : null}"
              style="font-family: 'Poppins-Medium';font-size: 19px;width: 225px;margin-top: 40px;">
              {{item.slider.publicice_detail.nom_bouton | uppercase }}
            </button>
          </div>
        </div>
      </slide>
    </carousel>
  </div>

  <!-- PICTO -->
  <div class="aboutUs py-3 mb-5">
    <div class="container pictos">
      <div class="row">
        <div class="col-6 col-md my-3 text-center payment">
          <div style="height: 2rem; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="width: auto; height: 100%;" svgIcon="picto-payment"></mat-icon>
          </div>
          <p class="pictos_p sfCompactDisplayMedium" style="font-size: 14px; margin-top: 2px;">{{'Paiement 100% sécurisé' | uppercase}}</p>
        </div>
        <div class="col-6 col-md my-3 text-center eco">
          <div style="height: 2rem; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="width: auto; height: 100%;" svgIcon="picto-contact"></mat-icon>
          </div>
          <p class="pictos_p sfCompactDisplayMedium" style="font-size: 14px; margin-top: 2px;">{{'Retours et échanges' | uppercase}}</p>
        </div>
        <div class="col-6 col-md my-3 text-center eco">
          <div style="height: 2rem; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="width: auto; height: 100%;" svgIcon="star"></mat-icon>
          </div>
          <p class="pictos_p sfCompactDisplayMedium" style="font-size: 14px; margin-top: 2px;">{{'Les grandes marques' | uppercase}}</p>
        </div>
        <div class="col-6 col-md my-3 text-center eco">
          <div style="height: 2rem; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="width: auto; height: 100%;" svgIcon="world"></mat-icon>
          </div>
          <p class="pictos_p sfCompactDisplayMedium" style="font-size: 14px; margin-top: 2px;">{{'Entreprises internationales' | uppercase}}</p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="slidersWithSousCategories && slidersWithSousCategories.length" class="container imageBlock">
    <div class="row imgpub pt-5">
      <div class="col-6 eco-friendly" *ngFor="let item of slidersWithSousCategories">
        <img width="auto" height="auto" loading="lazy" [src]="item.slider.publicice_detail.file.url" alt="" title="" style="height: 132px;object-fit: cover;">
        <div class="d-flex"
          [ngClass]="{'pl-3':item.slider.niveau_affichage === 'LEFT','justify-content-center': item.slider.niveau_affichage === 'CENTER','justify-content-end pr-3': item.slider.niveau_affichage === 'RIGHT'}"
          style="position: relative; top:-50%;">
          <div class="">
            <h4 [ngStyle]="{'color': getColor(item.slider.publicice_detail.couleur_texte)}">
              {{item.slider.publicice_detail.texte_achrochage}}</h4>
            <h5 [ngStyle]="{'color': getColor(item.slider.couleur_phrase)}">{{item.slider.phrase_acrochage}}</h5>
            <button
              class="btn {{getStyleButton(item.slider.publicice_detail.style_bouton)}}">{{item.slider.publicice_detail.nom_bouton
              | titlecase }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- NOTRE SELECTION -->
  <div class="container offer mb-2 mb-md-5" *ngIf="ventesFlashShow.min && ventesFlashShow.min.length">
    <p class="head-section" style="margin: 2% 0;">LES CHOUCHOUS DU MOIS</p>
    <app-produit-list [screenWidth]="screenWidth" [data]="ventesFlashShow" [idSlide]="'vf'" [login]="loginTemplate" type="venteflash"></app-produit-list>
  </div>

  <!-- UNIVERS -->
  <div class="container" *ngIf="dataUniverBox && dataUniverBox.sous_univers_homes && dataUniverBox.sous_univers_homes.length">
    <p class="head-section ajustement-title" style="margin: 2% 0;">LES DERNIÈRES TENDANCES</p>
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel" data-touch="true" data-interval="3000">
      <div class="carousel-inner">
        <div class="carousel-item" *ngFor="let itemArray of dataUniverBox.sous_univers_homes; let ind=index" [ngClass]="{'active': ind === 0}">
          <div class="row">
            <div class="col-12 col-md-4 col-lg-3 mb-3 pl-2" *ngFor="let item of itemArray.fils" style="min-height: 150px; cursor: pointer">
              <div class="univer_box py-3 py-md-4 px-md-3" [ngStyle]="{'background-color': item.value && checkColor(item.value) ? item.value : '#345B2B'}"
                style="width: 100%; height: 100%;" (click)="goToListing(item)">
                <div class="row pl-4 pl-md-0 flex-row-reverse">
                  <div class="col-6 col-md-12 pr-5 px-md-0 text-right text-md-center div-img">
                    <img width="auto" height="auto" loading="lazy" class="ml-auto my-auto horizontal-img" style="object-fit: cover;" [src]="commonService.getImageFormated(250, 250, item.image ? item.image : item.sous_univers?.url ? item.sous_univers.url : item.univers?.url)" [alt]="item.texte || item.texte2 || item.sous_univers.nom" [title]="item.texte || item.texte2 || item.sous_univers.nom" style="border-radius: 50%;">
                  </div>
                  <div class="col-6 col-md-12 text-md-center mt-2 content-suniver" style="height: 115px;overflow: hidden;">
                    <div class="d-flex flex-column-reverse flex-md-column">
                      <h3 class="mt-0 mb-0 PoppinsBold" *ngIf="item.texte && item.position.texte === 2" style="color: white; font-size: 20px; line-height: 28px;">{{ item.texte }}</h3>
                      <h3 class="mt-0 mb-0 PoppinsBold" *ngIf="item.value && item.position.texte2 === 2" style="color: white; font-size: 20px; line-height: 28px;">{{ item.texte2 }}</h3>
                      <h3 class="mt-0 mb-0 PoppinsBold" *ngIf="item.sous_univers && item.sous_univers.nom && item.position.sousUnivers === 2" style="color: white; font-size: 20px; line-height: 28px">{{ item.sous_univers.nom }}</h3>
                      <p class="mt-0 mb-0 PoppinsBold text-left" *ngIf="item.univers && item.univers.nb_produit && item.position.nbProduit === 2" style="color: white; font-size: 20px; line-height: 28px">{{ item.univers.nb_produit }} produits en vente</p>

                      <h2 class="mt-0 mb-0 PoppinsRegular" *ngIf="item.texte && item.position.texte === 1" style="color: white; font-size: 15px; font-weight: 400;word-wrap: break-word;"><span style="font-size: 0px;">articles </span>{{ item.texte }}<span style="font-size: 0px;"> Eco responsable</span></h2>
                      <h2 class="mt-0 mb-0 PoppinsRegular" *ngIf="item.value && item.position.texte2 === 1" style="color: white; font-size: 15px; font-weight: 400;word-wrap: break-word;"><span style="font-size: 0px;">articles </span>{{ item.texte2 }}<span style="font-size: 0px;"> Eco responsable</span></h2>
                      <h2 class="mt-0 mb-0 PoppinsRegular" *ngIf="item.sous_univers && item.sous_univers.nom && item.position.sousUnivers === 1" style="color: white; font-size: 15px; font-weight: 400;word-wrap: break-word;">{{ item.sous_univers.nom }}</h2>
                      <p class="mt-0 mb-0 PoppinsRegular text-left" *ngIf="item.univers && item.univers.nb_produit && item.position.nbProduit === 1" style="color: white; font-size: 15px; font-weight: 400;">{{ item.univers.nb_produit }} produits en vente</p>
                    </div>


                    <h4 class="mt-0 mb-0" *ngIf="item.texte && item.position.texte === 3" style="color: white; font-size: 15px;">{{ item.sous_univers.nom }}</h4>
                    <h4 class="mt-0 mb-0 " *ngIf="item.value && item.position.texte2 === 3" style="color: white; font-size: 15px;">{{ item.texte2 }}</h4>
                    <h4 class="mt-0 mb-0" *ngIf="item.sous_univers && item.sous_univers.nom && item.position.sousUnivers === 3" style="color: white; font-size: 15px;">{{ item.sous_univers.nom }}</h4>
                    <p class="mt-0 mb-0 text-left" *ngIf="item.univers && item.univers.nb_produit && item.position.nbProduit === 3" style="color: white; font-size: 15px;">{{ item.univers.nb_produit }} produits en vente</p>

                    <p class="mt-0 mb-1 text-left" *ngIf="item.texte && item.position.texte === 4" style="color: white; font-size: 14px; max-width: 200px;">{{ item.texte }}</p>
                    <p class="mt-0 mb-1 text-left" *ngIf="item.value && item.position.texte2 === 4" style="color: white; font-size: 14px; max-width: 200px;">{{ item.texte2 }}</p>
                    <p class="mt-0 mb-1 text-left" *ngIf="item.sous_univers && item.sous_univers.nom && item.position.sousUnivers === 4" style="color: white; font-size: 14px; max-width: 200px;">{{ item.sous_univers.nom }}</p>
                    <p class="mt-0 mb-1 text-left text-left" *ngIf="item.univers && item.univers.nb_produit && item.position.nbProduit === 4" style="color: white; font-size: 14px; max-width: 200px;">{{ item.univers.nb_produit }} produits en vente</p>
                  </div>                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <app-valeur></app-valeur>
  </div>

  <!-- A LA UNE -->
  <div class="listing-image mb-5 container px-0" *ngIf="aLaUnes && aLaUnes.length">
    <p class="text-center head-section" style="margin: 40px 0;">LES PÉPITES FRANÇAISES</p>
    <div class="row row-eq-height m-0 px-0 px-md-2">
      <div *ngFor="let item of aLaUnes" class="col-md-4 col-6 mb-2 col-xs-6 pb-0" [ngClass]="{'text-center': true}"
        [routerLink]="[item.a_la_une.publicice_detail.choix === 'PRODUIT' ? 'all-product/' + formatUrl(item.link.univers) + '/' + formatUrl(item.link.sousUnivers) + '/' + formatUrl(item.link.categorie) : item.vendeur ? '/detail-vendeur/' + formatUrl(item.vendeur.user.pseudo) + '-' + item.vendeur.user.id : '']"
        [queryParams]="{vendeur: item.a_la_une.publicice_detail.choix === 'BOUTIQUE' ? null : item.vendeur ? item.vendeur.user.id : null}">
        <div class="px-2 pb-2 une justify-content-center justify-content-between position-relative">
          <img class="w-100 h-100 position-absolute top-0" [src]="commonService.getImageFormated(350, 350, item.a_la_une.publicice_detail.file.url)" [alt]="item.a_la_une.publicice_detail.texte_achrochage" style="object-fit: cover;">
          <div class="h-50 d-sm-flex align-items-end">
            <h2 class="my-0 d-none d-sm-block" *ngIf="item.a_la_une.publicice_detail.texte_achrochage" style="line-height: 28px;z-index: 1;" [ngStyle]="{'color': getColor(item.a_la_une.publicice_detail.couleur_texte)}">
              {{item.a_la_une.publicice_detail.texte_achrochage | titlecase}}
            </h2>
          </div>
          <button
            class="h-50 {{getStyleButton(item.a_la_une.publicice_detail.style_bouton)}} btn-sm mb-md-2 rounded-pill"
            type="button" mat-flat-button>
            <h2 class="m-auto txt-btn">
              {{item.a_la_une.publicice_detail.nom_bouton | titlecase }}
            </h2>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- LES NOUVEAUTES -->
  <div class="container offer mb-5" *ngIf="(offresDuMomentShow.min || offresDuMomentShow.max) && (offresDuMomentShow.min.length && offresDuMomentShow.max.length)">
    <p class="head-section" style="margin: 2% 0;">LES PETITS DERNIERS</p>
    <app-produit-list [screenWidth]="screenWidth" [data]="offresDuMomentShow" [idSlide]="'om'" [login]="loginTemplate" type="offres"></app-produit-list>        
  </div>

  <ng-container *ngIf="aLaUnesWithSousCategories.length>0">
    <div class="offer" style="padding: 3% 0 3%;">
      <h2 class="head-section" style="margin: 0 0 2% 0;">NOS COUPS DE COEUR</h2>
      <app-heartstroke [products]="aLaUnesWithSousCategories"></app-heartstroke>
    </div>
  </ng-container>

  <!-- CREER VOTRE E BOUTIQUE QRCODE -->
  <div class="mt-5"></div>

  <div class="container">
    <app-e-boutique></app-e-boutique>
  </div>
</div>
